import React from 'react';
import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';
import CheckboxDataInput from "../../checkboxDataInput/CheckboxDataInput";
import { DROPDOWN_INPUT, INTEGER_PERCENTAGE_INPUT, MULTI_SELECT_DROPDOWN, REPERTOIRE_PAGE_FORM_ITEM_SIZE } from '../../../Consts';
import { InputNumber } from 'antd';

interface ToggleInputCheckboxProps {
    label: string;
    fieldName: string;
    checked: boolean;
    onChecked: (val: any, name: string) => void;
    isReadOnly: boolean;
    isHidden: boolean;
    onChange: (event: any, option?: any) => void;
    componentStyles?: any;
    fieldType: string;
    placeholder?: string;
    value?: any;
    selectedKeys?: any;
    options?: any[];
}
const componentContainerStyles = {
    marginTop: '10px'
}

const ToggleInputCheckbox: React.FC<ToggleInputCheckboxProps> = ({
    label,
    fieldName,
    checked,
    onChecked,
    isReadOnly,
    isHidden,
    onChange,
    componentStyles,
    fieldType,
    placeholder,
    value,
    selectedKeys,
    options
}) => {

    const handleKeyDown = (e) => {
        if (
            (e.key >= '0' && e.key <= '9') ||
            e.key === 'Backspace' ||
            e.key === 'ArrowLeft' ||
            e.key === 'ArrowRight' ||
            e.key === 'Tab' ||
            e.key === '.'
        ) {
            return;
        }
    
        e.preventDefault();
    };

    return (
        <div className={REPERTOIRE_PAGE_FORM_ITEM_SIZE} style={{ display: 'flex', flexDirection: 'column' }}>
            <CheckboxDataInput
                label={label}
                fieldName={fieldName}
                value={checked}
                changeData={onChecked}
                readonly={isReadOnly}
                isHidden={isHidden}
            />
            {checked ? (
                <div style={componentContainerStyles as React.CSSProperties}>
                    {(() => {
                        switch (fieldType) {
                            case DROPDOWN_INPUT:
                                return (
                                    <Dropdown
                                        title={label}
                                        selectedKeys={selectedKeys}
                                        options={options}
                                        multiSelect={false}
                                        onChange={onChange}
                                        placeholder={placeholder}
                                        styles={componentStyles}
                                        disabled={isReadOnly}
                                    />
                                );
                            case MULTI_SELECT_DROPDOWN:
                                return (
                                    <Dropdown
                                        title={label}
                                        selectedKeys={selectedKeys}
                                        options={options}
                                        multiSelect={true}
                                        onChange={onChange}
                                        placeholder={placeholder}
                                        styles={componentStyles}
                                        disabled={isReadOnly}
                                    />
                                );
                            case INTEGER_PERCENTAGE_INPUT:
                                return (
                                    <InputNumber
                                        value={value}
                                        min={0}
                                        max={100}
                                        onKeyDown={handleKeyDown}
                                        precision={2}
                                        step={10.00}
                                        readOnly={isReadOnly}
                                        onChange={value => onChange(value, fieldName)}
                                        style={componentStyles}
                                        disabled={isReadOnly}
                                    />
                                );
                            default:
                                return <></>;
                        }
                    })()}
                </div>
            ) : (
                <></>
            )}
        </div>
    );
};

export default ToggleInputCheckbox;